import { toast } from 'react-toastify';
export default function DummyPage2() {
  const notify = () => toast('Toast testing', {type: 'error'});
  return (
    <div className="App">
      <header className="App-header">
        <p className='text-green-300 font-bold'>
          Page 2
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        <button onClick={notify}>Notify!</button>
      </header>
    </div>
  );
}